import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Page404 from "app/not-found";

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageCommentaires = () => {
  const [commentaires, setCommentaires] = useState([]);
  const [message, setMessage] = useState("");

  // Récupérer l'utilisateur connecté depuis Redux
  const user = useSelector((state) => state.user.user);

  // Charger tous les commentaires
  useEffect(() => {
    getCommentaires();
  }, []);

  const getCommentaires = async () => {
    try {
      const res = await axiosInstance.get("api/commentaire");
      setCommentaires(res.data || []);
    } catch (error) {
      console.error("Erreur récupération commentaires:", error);
      setMessage("❌ Impossible de charger les commentaires.");
    }
  };

  // Supprimer un commentaire
  const handleSupprimerCommentaire = async (commentId) => {
    if (!window.confirm("Voulez-vous vraiment supprimer ce commentaire ?")) return;

    try {
      await axiosInstance.delete(`api/commentaire/${commentId}`);
      setMessage("✅ Commentaire supprimé");
      getCommentaires(); // rafraîchir liste
    } catch (error) {
      console.error("Erreur suppression commentaire:", error);
      setMessage("❌ Impossible de supprimer le commentaire.");
    }
  };

  if (!user) return <Page404 />;
  
  return (
    <div
      style={{
        margin: "50px",
        textAlign: "justify",
      }}
    >
      <h2>📌 Tous les commentaires</h2>

      <div style={{ marginTop: "30px" }}>
        {commentaires.length > 0 ? (
          commentaires.map((c, idx) => {
            const date =
              c.createdAt
                ? new Date(c.createdAt).toLocaleDateString("fr-CA")
                : "";

            return (
              <div
                key={idx}
                style={{
                  marginBottom: "20px",
                  padding: "12px",
                  borderBottom: "1px solid #ddd",
                }}
              >
                {/* Ligne principale : nom + commentaire + date + X */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <span style={{ flex: 1 }}>
                    <strong>{c.nom}</strong> : {c.commentaire}
                  </span>

                  <div
                    style={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <small style={{ color: "gray", whiteSpace: "nowrap" }}>
                      {date}
                    </small>
                    {user && (user.role === "admin" || user.role === "editor") && (
                      <button
                        onClick={() => handleSupprimerCommentaire(c._id)}
                        style={{
                          background: "transparent",
                          border: "none",
                          color: "red",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        title="Supprimer ce commentaire"
                      >
                        X
                      </button>
                    )}
                  </div>
                </div>

                {/* Ligne article : titre + lien */}
                {c.idArticle && (
                  <div style={{ marginTop: "5px" }}>
                    <a
                      href={c.idArticle.href}
                      style={{
                        color: "#007BFF",
                        textDecoration: "none",
                        fontSize: "0.9em",
                      }}
                    >
                      ↪ {c.idArticle.titre}
                    </a>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <p>Aucun commentaire pour l’instant.</p>
        )}
      </div>

      {message && <p style={{ marginTop: "15px" }}>{message}</p>}
    </div>
  );
};

export default PageCommentaires;
